import React from 'react';
import Navigation from '../../components/common/Navigation';
import { useHistory } from 'react-router-dom';
import HeaderContainer from '../../containers/common/HeaderContainer';
import { SideSpacer } from '../../components/common/Spacer';
import {
  CommonContainer,
  HorizonWrapper,
} from '../../components/common/Container';
import MydingoSmartStoreContainer from '../../containers/smartstore/MydingoSmartStoreContainer';

const MydingoSmartStorePage = () => {

  return (
    <>
      <HeaderContainer />
      <Navigation />
      <SideSpacer>
        
        <HorizonWrapper>
          <CommonContainer>
              <MydingoSmartStoreContainer />
          </CommonContainer>
        </HorizonWrapper>
      </SideSpacer>
    </>
  );
};

export default MydingoSmartStorePage;

